require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ifc-must-implement-the-recommendations-of-its-external.json") })
        }
      }, "path---en-us-update-ifc-must-implement-the-recommendations-of-its-external");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ifc-must-implement-the-recommendations-of-its-external!./.cache/json/en-us-update-ifc-must-implement-the-recommendations-of-its-external.json
// module id = 753
// module chunks = 231608221292675